import LegalPageLayout from "@/components/LegalPageLayout";
import PrivacyPolicyContent from "@/components/legal/PrivacyPolicyContent";
import { legalDocumentById } from "@/utils/legalDocs";

const DOC = legalDocumentById("privacy");

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title={DOC.title} lastUpdated={DOC.lastUpdated}>
      <PrivacyPolicyContent />
    </LegalPageLayout>
  );
}
